import React from 'react';
import MapModal from './MapModal';
const Loading = ({ message = 'Loading', inline }) => {
    return (React.createElement(MapModal, { className: `cm-modal--transparent-overlay ${inline ? 'cm-modal--transparent-overlay-inline' : ''}`, isOpen: true, showClose: false, inline: inline },
        React.createElement("p", { className: "cm__loading-spinner xlarge-font flex-center block-padding-y--normal", "data-spinner-on": "true" }),
        React.createElement("h2", { className: "cm-modal__title" }, message)));
};
export default React.memo(Loading);
